export default function listeners() {
  let all = [];

  const add = (element, event, func) => {
    all.push({ element, event, func });
    element.addEventListener(event, func);
  };

  const removeAll = () => {
    all.forEach(listener => {
      listener.element.removeEventListener(listener.event, listener.func);
    });
    all.length = 0;
  };

  return { add, removeAll };
}
